export default __webpack_public_path__ + "static/media/cal-day.bdfacd86.jpg";